import React from "react";
import Title from "../../../components/Title";
import Filters from "../../../components/Filters";
import { useSelector } from "react-redux";
import AddEmail from "./AddEmail";

const TableHeader = () => {
  const { language } = useSelector((state) => state.Language);

  return (
    <div className="mb-3 flex items-center justify-between flex-wrap">
      <Title text={language["email_setting_page_title"]} />
      <div className="flex items-center flex-wrap gap-3">
        <Filters
          apiName="getEmailSetting"
          recordName="emailList"
          placeholder={language["email_setting_search_placeholder"]}
          dateWidth={"220px"}
          searchboxWidth={"250px"}
          customQuery={{ status: "active" }}
          dateFilter={false}
        />
        <AddEmail />
      </div>
    </div>
  );
};

export default TableHeader;
